import { VOICE_ROUTE_LABEL } from "./voiceInbox.const";
import { isChatbotsReleaseEnabled, isChatbotsfeatureEnabled, isKbInclusionInChatFeatureEnabled } from "../utils";
import { isDeltaFeatureOnTrial } from "../../sharedmailbox/common/TrialAddon/util";
import { getFeatureKey } from "../../sharedmailbox/common/TrialAddon/constants";
import { AI_SUGGESTIONS } from "../../common";
import { isChatTransciptsEnabled } from "h-commons";

const EMAIL_CHANNEL = 'email';
const CHAT_CHANNEL = 'chat';
const WHATSAPP_CHANNEL = 'whatsapp';
const DEFAULT_APP_ROUTE = '/app/sharedmailbox';
const DASHBOARD_ROUTE = "/app/dashboard";
const WHATSAPP_ROUTE = `${DEFAULT_APP_ROUTE}/whatsapp/`;
const FULL_CREATE_WHATSAPP_ROUTE = `${WHATSAPP_ROUTE}create`;
const WHATSAPP_ONBOARD_URL = `${WHATSAPP_ROUTE}onBoarding`;
const GENERAL_INFO_ROUTE = `${FULL_CREATE_WHATSAPP_ROUTE}/generalInformation`;
const CONNECT_WA_ROUTE = `${FULL_CREATE_WHATSAPP_ROUTE}/connectNumber`;
const WEBHOOK_WA_ROUTE = `${FULL_CREATE_WHATSAPP_ROUTE}/setupWebhooks`;
const CHAT_ROUTE = 'sharedmailbox/chat/';

const CREATE_CHAT_ROUTE = [
  { label: 'General information', to: '/generalInformation' },
  { label: 'Chat widget', to: '/chatWidget' },
  { label: 'Bot configuration', to: '/botConfiguration' },
];

const CREATE_WHATSAPP_ROUTE = [
  { label: 'General information', to: '/generalInformation' },
  { label: 'Connect your number', to: '/connectNumber' },
  { label: 'Setup webhooks', to: '/setupWebhooks' }
];

const EDIT_CHAT_ROUTE = (availablefeatures, deltaFeatures) => [
  { label: 'Participants', to: '/participants' },
  { label: 'Auto assignment', to: '/autoassignment' },
  { label: 'Widget design', to: '/widgetdesign' },
  { label: 'Bot configuration', to: '/botConfiguration' },
  { label: 'Nudges', to: '/nudges', isExploringHigherPlan: isDeltaFeatureOnTrial(getFeatureKey('Nudges'), deltaFeatures)},
  { label: 'Help articles in chat', to: '/kb-articles-in-chat', hasUpgrade: !isKbInclusionInChatFeatureEnabled(availablefeatures)},
  { label: 'Pre-chat form', to: '/prechatform' },
  { label: 'Unavailability settings', to: '/unavailabilitysettings' },
  { label: 'Chatbot', to: '/chatbots', hasUpgrade: isChatbotsReleaseEnabled(availablefeatures) && !isChatbotsfeatureEnabled(availablefeatures), showBetaTag: false},
  { label: 'Transcripts', to: '/transcripts', hasUpgrade: !isChatTransciptsEnabled(availablefeatures)},
  { label: 'General settings', to: '/generalsettings' },
  { label: AI_SUGGESTIONS, to: '/chatSuggestions' }
];

const EDIT_WHATSAPP_ROUTE = [
  { label: 'Participants', to: '/participants' },
  { label: 'General settings', to: '/generalSetting' },
  { label: 'Configuration', to: '/configuration' }
];

const VOICE_CHANNEL = 'voice';

const CREATE_VOICE_ROUTE = [
  { label: VOICE_ROUTE_LABEL.SETUP, to: '/setup' },
  { label: VOICE_ROUTE_LABEL.GENERAL_SETTINGS, to: '/generalsettings' },
];

const EDIT_VOICE_ROUTE = [
  { label: VOICE_ROUTE_LABEL.GENERAL_SETTINGS, to: '/manage' },
  { label: VOICE_ROUTE_LABEL.PARTICIPANTS, to: '/participants' },
];

const NO_SIDEBAR_ROUTES = ['chat/create/success', 'sharedmailbox/create/success'];
const EMOJIS_REGEX = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/;

const ERROR_TEXT = {
  required: 'This field cannot be empty',
  inboxNameExists: 'This inbox name already exists. Please rename',
  specialCharacters: 'Special characters cannot be used in inbox name'
}

const WHATSAPP_CONNECT_TEXTS = {
  headerText: 'Connect your number',
  headerDescription: `<div>You can obtain the below information from your Facebook developer dashboard. We recommend going through our <a href='https://help.hiverhq.com/whatsapp-channel/facebook-developer-portal-hiver' target='_blank'>step-by-step guide</a> for reference.</div>`,
  phoneNumber: 'Phone number',
  numberDescription: 'Enter your WhatsApp phone number where customer queries are received',
  inputs: [
    {
      id: 'phoneNumber',
      text: 'Phone number',
      description: 'Enter your WhatsApp phone number where customer queries are received',
      isNumberField: true,
      dropDownPlaceHolder: 'Search country',
      errorText: 'This field cannot be empty'
    },
    {
      id: 'numberID',
      text: 'Phone number ID',
      description: 'Enter the phone number ID present on Facebook developer dashboard',
      placeholder: 'Eg: 109349875167509',
      errorText: 'This field cannot be empty'
    },
    {
      id: 'businessID',
      text: 'WhatsApp business account ID',
      description: 'Enter the business account ID present on Facebook developer dashboard',
      placeholder: 'Eg: 104241872352685',
      errorText: 'This field cannot be empty'
    },
    {
      id: 'apiKey',
      text: 'Permanent access token',
      description: `<div>Learn how to create a permanent access token <a href='https://help.hiverhq.com/whatsapp-channel/facebook-developer-portal-hiver' target='_blank'>here</a></div>`,
      placeholder: 'Eg: 0imfnc8mVLWwsAawjYr4Rx-Af50DDqtlx',
      errorText: 'This field cannot be empty'
    }
  ],
  next: 'Next',
  create: 'Create Inbox'
}

const PARTICIPANTS_LIST_INITIAL = {
  columns: [
    {
      label: 'Name',
      sortable: true,
      accessor: (user) => {
        if (user.first_name && user.last_name)
          return `${user.first_name} ${user.last_name}`;
        else if (user.first_name && !user.last_name) return `${user.first_name}`;
        else return user.name;
      },
    },
    { label: 'Email ID', accessor: 'email', sortable: true },
  ],
};

const INVITED_USER_COLOR = 'rgb(239, 239, 239)';

const LEARN_MORE_LINK_URL = {
  AIRCALL: 'https://help.hiverhq.com/voice-channel/hiver-aircall-integration-synopsis',
};

export {
  EMAIL_CHANNEL,
  CHAT_CHANNEL,
  CREATE_CHAT_ROUTE,
  EDIT_CHAT_ROUTE,
  NO_SIDEBAR_ROUTES,
  EMOJIS_REGEX,
  PARTICIPANTS_LIST_INITIAL,
  ERROR_TEXT,
  INVITED_USER_COLOR,
  VOICE_CHANNEL,
  CREATE_VOICE_ROUTE,
  EDIT_VOICE_ROUTE,
  CREATE_WHATSAPP_ROUTE,
  WHATSAPP_CONNECT_TEXTS,
  WHATSAPP_CHANNEL,
  CHAT_ROUTE,
  EDIT_WHATSAPP_ROUTE,
  WHATSAPP_ROUTE,
  CONNECT_WA_ROUTE,
  WEBHOOK_WA_ROUTE,
  LEARN_MORE_LINK_URL,
  WHATSAPP_ONBOARD_URL,
  GENERAL_INFO_ROUTE,
  DEFAULT_APP_ROUTE,
  DASHBOARD_ROUTE
};
